// extracted by mini-css-extract-plugin
export default {"container":"Card_container__Tj4G4","content":"Card_content__yWMlq","img":"Card_img__Z-bSU","text":"Card_text__eOgIz"};